import React, { useState, useEffect } from 'react';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import Preloader from '../../components/Preloader';

const containerStyle = {
  width: '100%',
  height: '800px',
};

const UbicacionVenta = ({ form, setForm }) => {
  const [ubicacion, setUbicacion] = useState(null);
  const [marcador, setMarcador] = useState(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  useEffect(() => {
    if (form.latitud && form.longitud) {
      const lat = Number(form.latitud);
      const lng = Number(form.longitud);
      const coords = { lat: lat, lng: lng };
      setUbicacion(coords);
      setMarcador(coords);
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          const coords = { lat: latitude, lng: longitude };
          setUbicacion(coords);
          setMarcador(coords);
          setForm((prev) => ({
            ...prev,
            latitud: latitude,
            longitud: longitude,
          }));
        },
        () => {
          const fallback = { lat: 10.4806, lng: -66.9036 };
          setUbicacion(fallback);
          setMarcador(fallback);
        }
      );
    } else {
      const fallback = { lat: 10.4806, lng: -66.9036 };
      setUbicacion(fallback);
      setMarcador(fallback);
    }
  }, []);

  const handleMapClick = (e) => {
    const nuevaUbicacion = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setMarcador(nuevaUbicacion);
    setUbicacion(nuevaUbicacion);
    setForm((prev) => ({
      ...prev,
      latitud: nuevaUbicacion.lat,
      longitud: nuevaUbicacion.lng,
    }));
  };

  if (loadError) return <div>Error cargando el mapa</div>;
  if (!isLoaded || !ubicacion) return <Preloader />;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={ubicacion}
      zoom={15}
      onClick={handleMapClick}
    >
      {marcador && <MarkerF position={marcador} />}
    </GoogleMap>
  );
};

export default UbicacionVenta;
